export default __webpack_public_path__ + "static/media/coffee.10539dff.webp";